var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("exchange_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('exchange_page.form_desc'))
    }
  }), _vm.getModuleConfig('exchange_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('exchange_page.content'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "pointes-list"
  }, [_vm._l(_vm.gifts, function (item) {
    return _c('PointCard', {
      key: item.id,
      attrs: {
        "item": item
      },
      on: {
        "exchange": _vm.handleExchange
      }
    });
  }), _c('PointPagination', {
    attrs: {
      "totalPage": _vm.totalPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('Popup', {
    ref: "popupUsage",
    attrs: {
      "panelHeight": "auto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" 是否確定要使用 "), _c('span', {
    staticClass: "s-primary"
  }, [_vm._v(_vm._s(_vm.popup.point.toLocaleString()))]), _vm._v(" 點 ")]), _c('div', {
    staticClass: "s-mt-5 s-mb-5 s-text-center"
  }, [_vm._v(" 請注意，點數一經使用即無法取消 ")]), _c('div', {
    staticClass: "s-flex s-space-x-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.popupUsage.close();
      }
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleChooseUsage
    }
  }, [_vm._v(" 確定 ")])])])], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }